import { render } from "./user-agreement.vue?vue&type=template&id=ef821016&scoped=true"
import script from "./user-agreement.vue?vue&type=script&lang=js"
export * from "./user-agreement.vue?vue&type=script&lang=js"

import "./user-agreement.vue?vue&type=style&index=0&id=ef821016&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef821016"]])

export default __exports__